import { render, staticRenderFns } from "./ColoredCircleDecorator.vue?vue&type=template&id=5a650974&scoped=true&"
import script from "./ColoredCircleDecorator.vue?vue&type=script&lang=js&"
export * from "./ColoredCircleDecorator.vue?vue&type=script&lang=js&"
import style0 from "./ColoredCircleDecorator.vue?vue&type=style&index=0&id=5a650974&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a650974",
  null
  
)

export default component.exports